import { useEffect, useState } from "react";
import { userData } from "../js/utils";
import { post } from "../js/post";

export function useGlassesTypes() {
  const [list, setList] = useState([]);

  async function getData() {
    const response = await post("support-extra/fichas/ListarTipoGafas.php", {
      token: userData.token,
    });
    setList([...response.map((e) => ({ id: e.tipo, text: e.descripcion }))]);
  }

  useEffect(() => {
    getData();
  }, []);

  return list;
}
